import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import 'mdb-react-ui-kit/dist/css/mdb.min.css'

export const msalInstance = new PublicClientApplication(msalConfig);


createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App msalInstance={msalInstance}/>
  </React.StrictMode>
);

//reportWebVitals();
